<template>
  <div class="bg">
    <a-card title="界面模板" :bordered="false">
      <a-row>
        <a-col :span="8" v-for="(item, index) in tempList" :key="index">
          <TempItem style="margin: 10px;" :dataObj="item"></TempItem>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="8">
          <a-form-model layout="vertical" ref="ruleForm" :form="form" :rules="rules" :model="form">
            <a-form-model-item>
              <a-button type="primary" @click="handleSubmit">{{$t('actionTitles.submit')}}</a-button>
              <a-button style="margin-left: 10px;">{{$t('actionTitles.cancel')}}</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import TempItem from "./TempItem.vue";
import { mapGetters } from "vuex";
export default {
  components: { TempItem },
  data() {
    return {
      tempList: [{ sre: "" }, { sre: "" }, { sre: "" }, { sre: "" }],
      form: {},
      rules: {},
    };
  },
  computed: { ...mapGetters(["vrbase"]) },
  created() {
    this.tempList = this.$deepClone(this.vrbase.scenes);
    console.log("tempList", this.tempList);
  },
  methods: {
    handleSubmit() {},
  },
};
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  height: 100%;
}
</style>